import { emptyIfInvalid } from '../../../utils/value.js';
import { ColorReference, Keyword, Length } from '../../values/index.js';
import { fixReference as fixColorReference } from '../basic/color.js';
import { formatSideDimensions } from '../../../utils/summary.js';
// Border
export var BorderStyle;
(function (BorderStyle) {
    BorderStyle["solid"] = "solid";
    BorderStyle["dashed"] = "dashed";
    BorderStyle["dotted"] = "dotted";
    BorderStyle["double"] = "double";
})(BorderStyle || (BorderStyle = {}));
export const Border = (props = {}) => ({
    borderStyle: Keyword(props.borderStyle, BorderStyle),
    borderColor: ColorReference(props.borderColor),
    borderLeftWidth: Length(props.borderLeftWidth),
    borderRightWidth: Length(props.borderRightWidth),
    borderTopWidth: Length(props.borderTopWidth),
    borderBottomWidth: Length(props.borderBottomWidth)
});
Border.isValid = (props) => ColorReference.isValid(props.borderColor) &&
    (props.borderLeftWidth.value != 0 ||
        props.borderRightWidth.value != 0 ||
        props.borderTopWidth.value != 0 ||
        props.borderBottomWidth.value != 0);
Border.Fix = (props, styles) => ({
    ...Border(props),
    borderColor: fixColorReference(props.borderColor, styles)
});
// Border radius
export const BorderRadius = (props = {}) => ({
    borderTopLeftRadius: Length(props.borderTopLeftRadius),
    borderTopRightRadius: Length(props.borderTopRightRadius),
    borderBottomLeftRadius: Length(props.borderBottomLeftRadius),
    borderBottomRightRadius: Length(props.borderBottomRightRadius)
});
BorderRadius.isValid = (props) => props.borderTopLeftRadius.value != 0 ||
    props.borderTopRightRadius.value != 0 ||
    props.borderBottomLeftRadius.value != 0 ||
    props.borderBottomRightRadius.value != 0;
BorderRadius.Fix = (props, styles) => ({
    ...BorderRadius(props)
});
// Box shadow
export const BoxShadow = (props = {}) => ({
    boxShadowInset: !!props.boxShadowInset,
    boxShadowOffsetX: Length(props.boxShadowOffsetX),
    boxShadowOffsetY: Length(props.boxShadowOffsetY),
    boxShadowBlurRadius: Length(props.boxShadowBlurRadius),
    boxShadowSpreadRadius: Length(props.boxShadowSpreadRadius),
    boxShadowColor: ColorReference(props.boxShadowColor)
});
BoxShadow.isValid = (props) => ColorReference.isValid(props.boxShadowColor) &&
    (props.boxShadowOffsetX.value != 0 ||
        props.boxShadowOffsetY.value != 0 ||
        props.boxShadowBlurRadius.value != 0 ||
        props.boxShadowSpreadRadius.value != 0);
BoxShadow.Fix = (props, styles) => ({
    ...BoxShadow(props),
    boxShadowColor: fixColorReference(props.boxShadowColor, styles)
});
export const Props = (props = {}) => ({
    ...emptyIfInvalid(props, Border),
    ...emptyIfInvalid(props, BorderRadius),
    ...emptyIfInvalid(props, BoxShadow)
});
export const fix = (props, styles) => ({
    ...Border.Fix(props, styles),
    ...BorderRadius.Fix(props, styles),
    ...BoxShadow.Fix(props, styles)
});
export const validate = () => true;
export const label = 'Decoration';
export const type = 'decoration';
export const property = 'decorationIds';
export const forms = [
    {
        id: 'decorationRadius',
        label: 'Corner radius',
        extractProperties: (props) => BorderRadius(props),
        validate: BorderRadius.isValid
    },
    {
        id: 'decorationShadow',
        label: 'Drop shadow',
        extractProperties: (props) => BoxShadow(props),
        validate: BoxShadow.isValid
    },
    {
        id: 'decorationBorder',
        label: 'Border',
        extractProperties: (props) => Border(props),
        validate: Border.isValid
    }
];
export const category = 'aspect';
export const summarize = (props, styles, formId) => {
    switch (formId) {
        case 'decorationRadius':
            const radius = formatSideDimensions(props.borderTopLeftRadius.value + props.borderTopLeftRadius.unit, props.borderTopRightRadius.value + props.borderTopRightRadius.unit, props.borderBottomLeftRadius.value + props.borderBottomLeftRadius.unit, props.borderBottomRightRadius.value + props.borderBottomRightRadius.unit);
            return radius == '9999px' ? 'Rounded' : radius;
        case 'decorationShadow':
            return props.boxShadowOffsetX.value || props.boxShadowOffsetY.value
                ? props.boxShadowInset
                    ? 'Inner'
                    : 'Outer'
                : 'None';
        case 'decorationBorder':
            return `${formatSideDimensions(props.borderTopWidth.value + props.borderTopWidth.unit, props.borderBottomWidth.value + props.borderBottomWidth.unit, props.borderLeftWidth.value + props.borderLeftWidth.unit, props.borderRightWidth.value + props.borderRightWidth.unit)}`;
        default:
            return `${formatSideDimensions(props.borderTopWidth.value + props.borderTopWidth.unit, props.borderBottomWidth.value + props.borderBottomWidth.unit, props.borderLeftWidth.value + props.borderLeftWidth.unit, props.borderRightWidth.value + props.borderRightWidth.unit)}`;
    }
};
//# sourceMappingURL=decoration.js.map